import {
  getOrderTemplateRequest, getUsersList,
} from '../../../api/api'
import {getUrl} from "../../../utils/global/geturl";  // 导入封装后的axios请求

const state = {}

const getters = {}

const actions = {
  async getTemplateList ({commit}, params) {
    return getOrderTemplateRequest(getUrl(params)).then(response => response)
    // return getOrderTemplateRequest(params).then(response => response)
  },
};

const mutations = {}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/ordertpl/ordertpl.js